import axios from 'axios';
import { NCH_ENV } from '../../js/nch-env';

/**
 * Variáveis de ambiente do frontend (website do aluno) expostas em `window.axios.*`.
 *
 * Fonte: NCH_ENV (runtime via window.__NCH_ENV, com fallback para VITE_* do
 * build). Substitui o comportamento do plugin MixDefinitionsPlugin.
 *
 * IMPORTANTE — ordem de carga: `app.js` executa
 * `window.axios = axios` DEPOIS deste módulo, o que descartava qualquer objeto
 * criado aqui (as chaves sumiam e `window.axios.HUB_API` ficava undefined).
 * Por isso as chaves são gravadas também na própria instância do axios: como
 * todos os `window.axios = axios` apontam para essa mesma instância, as
 * chaves sobrevivem independentemente da ordem.
 */
export const ENV_KEYS = {
    ASSETS_API: NCH_ENV.ASSETS_API,
    HUB_API: NCH_ENV.HUB_API,
    JMV_MIDDLEWARE: NCH_ENV.JMV_MIDDLEWARE,
    NOCHALKS_MIDDLEWARE: NCH_ENV.NOCHALKS_MIDDLEWARE,
    ZIP_API: NCH_ENV.ZIP_API,
    NOMINATIN_API: NCH_ENV.NOMINATIN_API,
    PLAYER_DOMAIN: NCH_ENV.PLAYER_DOMAIN,
    BROADCAST_PREFIX: NCH_ENV.BROADCAST_PREFIX,
    BROADCAST_ASSETS_PREFIX: NCH_ENV.BROADCAST_ASSETS_PREFIX,
    API_JMVSTREAM: NCH_ENV.API_JMVSTREAM,
    APP_HOST: NCH_ENV.APP_HOST,
};

/**
 * Grava as variáveis de ambiente no alvo informado (a instância do axios é uma
 * FUNÇÃO com propriedades — por isso aceita object e function; ou
 * qualquer outro alvo que o código legado use como `window.axios`).
 *
 * @param {object} target
 * @returns {object} o próprio target
 */
export function applyEnv(target) {
    if (target && (typeof target === 'object' || typeof target === 'function')) {
        Object.assign(target, ENV_KEYS);
    }
    return target;
}

applyEnv(axios);
window.axios = window.axios || axios;
applyEnv(window.axios);

// Ferramentas de compatibilidade com Mix
const mixCompat = {
    inProduction() {
        return process.env.NODE_ENV === 'production';
    },
    version() {
        return this;
    },
    alias() {
        return this;
    },
    extract() {
        return this;
    },
    sourceMaps() {
        return this;
    },
    webpackConfig() {
        return this;
    },
};

export default mixCompat;
